import { ActivityPart } from '@/api/models/activityParts'
import { ActivityConstraintReducedModel, ActivityWithAggregate } from '@/api/models/aggregate'

type ActivityConstraintReducedModelKeys = keyof ActivityConstraintReducedModel
type ActivityConstraintReducedModelValues = ActivityConstraintReducedModel[ActivityConstraintReducedModelKeys]

export function mergeConstraints(
  parentActivityPart: ActivityPart<ActivityWithAggregate> | null,
  activityPart: ActivityPart<ActivityWithAggregate>,
) {
  const parentConstraint = parentActivityPart?.activityConstraint
  const childConstraint = activityPart?.activityConstraint

  const ignoreFields = ['reviewPolicy', 'resultsDisclosurePolicy'] as ActivityConstraintReducedModelKeys[]

  const getMergedValue = (
    key: ActivityConstraintReducedModelKeys,
    parentValue: ActivityConstraintReducedModelValues,
  ) => {
    const isIgnoredField = ignoreFields.includes(key)
    const childValue = childConstraint?.[key]

    return isIgnoredField ? childValue : (childValue ?? parentValue)
  }

  return Object.fromEntries(
    Object.entries(parentConstraint || childConstraint).map(([key, value]) => [
      key,
      getMergedValue(key as ActivityConstraintReducedModelKeys, value),
    ]),
  ) as ActivityConstraintReducedModel
}
